import { Table } from '../../entities/Table'
import { httpClient } from '../http/httpClient'

export interface TableParams {
  limit?: number;
  skip?: number;
  sort?: string;
  isActive?: string;
  type?: string;
  forLinkCreation?: boolean;
}

export interface TableResponse {
  tables: Table[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
    order: string
  }
}

export const table = async (params: TableParams | undefined) => {
  const { data } = await httpClient.get<TableResponse>('/table', { params })

  return data
}
